import { createIcon } from '@/utils/IconUtil';
import request from '@/utils/request';
import type { MenuDataItem } from '@umijs/route-utils';

/** 获取当前的用户 GET /waterbase/getUserInfo */
export async function getUserInfo(options?: Record<string, any>) {
  return request<API.GetUserInfoResult>('/waterbase/getInfo', {
    method: 'GET',
    ...(options || {}),
  });
}

// 获取加密userId
export async function getAIUserId(params: Record<string, any>) {
  return request<Record<string, any>>('/v1/user/info', {
    method: 'GET',
    params,
  });
}

// export async function getUserInfo (options?: Record<string, any>) {
//   return request<API.GetUserInfoResult>('/waterbase/system/user/profile', {
//     method: 'GET',
//     ...(options || {}),
//   });
// }

/** 退出登录接口 POST /waterbase/login/outLogin */
export async function logout(options?: Record<string, any>) {
  return request<Record<string, any>>('/waterbase/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

export async function getRouters(): Promise<API.GetRoutersResult> {
  return request('/waterbase/getRouters');
}

export function convertCompatRouters(childrens: API.RoutersMenuItem[]): MenuDataItem[] {
  if (!childrens) return [];
  return childrens.map((item: API.RoutersMenuItem) => {
    return {
      path: item.path,
      icon: createIcon(item.meta.icon),
      name: item.meta.title,
      routes: item.children ? convertCompatRouters(item.children) : undefined,
      hideChildrenInMenu: item.hidden,
      hideInMenu: item.hidden,
      component: item.component,
      authority: item.perms,
      hasChild: item.hasChild,
      isAlive: !item?.meta?.noCache,
      query: item.query,
    };
  });
}

export async function getRoutersInfo(): Promise<MenuDataItem[]> {
  return getRouters().then((res) => {
    return convertCompatRouters(res.data);
  });
}

export function getMatchMenuItem(
  path: string,
  menuData: MenuDataItem[] | undefined,
): MenuDataItem[] {
  if (!menuData) return [];
  let items: MenuDataItem[] = [];
  menuData.forEach((item) => {
    if (item.path) {
      if (item.path === path) {
        items.push(item);
        return;
      }
      if (path.length >= item.path?.length) {
        const exp = `${item.path}/*`;
        if (path.match(exp) || item.path === '/') {
          if (item.routes) {
            const subpath = path.substr(item.path.length + 1);
            const subItem: MenuDataItem[] = getMatchMenuItem(subpath, item.routes);
            items = items.concat(subItem);
          } else {
            const paths = path.split('/');
            if (paths.length >= 2 && paths[0] === item.path && paths[1] === 'index') {
              items.push(item);
            }
            if (paths.length >= 2 && item.path + '/index/:id?' === path) {
              items.push(item);
            }
          }
        }
      }
    }
  });
  return items;
}
export function getIsAlive(path: string, menuData: MenuDataItem[] | undefined): MenuDataItem[] {
  if (!menuData) return [];
  let items: MenuDataItem[] = [];
  menuData.forEach((item) => {
    if (item.path) {
      if (item.path === path && item.isAlive) {
        items.push(item);
        return;
      }
      if (path.length >= item.path?.length) {
        const exp = `${item.path}/*`;
        if (path.match(exp)) {
          if (item.routes) {
            const subpath = path.substr(item.path.length + 1);
            const subItem: MenuDataItem[] = getIsAlive(subpath, item.routes);
            items = items.concat(subItem);
          } else {
            const paths = path.split('/');
            if (
              paths.length >= 2 &&
              paths[0] === item.path &&
              paths[1] === 'index' &&
              item.isAlive
            ) {
              items.push(item);
            }
          }
        }
      }
    }
  });
  return items;
}
